import { Injectable } from "@angular/core";
import { AppStateService } from "./app-state.service";

declare let window: any; // Allow access to global window object

@Injectable({
  providedIn: "root",
})
export class GtmService {
  constructor(private appState: AppStateService) {}

  /*
    Format of creating and pushing a gtm into a datalayer
  */
  pushTag(data: any) {
    if (window && window.dataLayer) {
      window.dataLayer.push({
        ...data,
        step_name: "http://intl.senecacollege.ca/application/" + data.step_name,
        application_number: this.appState.applicantInfo.appId,
        previous_student_id: this.appState.personalInfo.previousStudentID,
        user_id: this.appState.personalInfo.email,
      });
    } else {
      console.warn("GTM not initialized");
    }
  }
}
